import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import SimplePage from '../../views/modules/simplePage';
// routes config

const CheckPath = ({ defaultRoute, isLoading, t, pages, pagesSettings, pathName, ...props }) => (

  <React.Fragment>
    { !isLoading && (
    <Switch>
      {pages.includes(pathName) && (
        <SimplePage page={pagesSettings[pathName]} id={pagesSettings[pathName].id}{...props} />
      )}
      <Redirect from="*" to={defaultRoute} />
    </Switch>
     )}
  </React.Fragment>
);

CheckPath.propTypes = {
  t: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default CheckPath;



// WEBPACK FOOTER //
// ./src/components/checkPath/CheckPath.js